module.exports = __webpack_public_path__ + "613a5aeaa7bd4b089ede5c63428b434f.png";